const EMPLOYEE_SALE_BRAND_SLUG = "balenciaga";

module.exports = {
  EMPLOYEE_SALE_BRAND_SLUG,
};
